/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_HomepageInputs */

const en_shared_homepage = /** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homepage`)
};

const nl_shared_homepage = /** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homepage`)
};

/** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */
const de_shared_homepage = en_shared_homepage;

/** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */
const es_shared_homepage = en_shared_homepage;

/** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */
const fr_shared_homepage = en_shared_homepage;

/** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */
const it_shared_homepage = en_shared_homepage;

/** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */
const pt_br2_shared_homepage = en_shared_homepage;

/** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */
const pl_shared_homepage = en_shared_homepage;

/** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */
const hu_shared_homepage = en_shared_homepage;

/** @type {(inputs: Shared_HomepageInputs) => LocalizedString} */
const ro_shared_homepage = en_shared_homepage;

/**
* | output |
* | --- |
* | "Homepage" |
*
* @param {Shared_HomepageInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_homepage = /** @type {((inputs?: Shared_HomepageInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_HomepageInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_homepage(inputs)
	if (locale === "de") return de_shared_homepage(inputs)
	if (locale === "es") return es_shared_homepage(inputs)
	if (locale === "fr") return fr_shared_homepage(inputs)
	if (locale === "nl") return nl_shared_homepage(inputs)
	if (locale === "it") return it_shared_homepage(inputs)
	if (locale === "pt-BR") return pt_br2_shared_homepage(inputs)
	if (locale === "pl") return pl_shared_homepage(inputs)
	if (locale === "hu") return hu_shared_homepage(inputs)
	return ro_shared_homepage(inputs)
});
export { shared_homepage as "shared.homepage" }